import React from "react";
import { Box, useTheme } from "@mui/material";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { KPICard } from "./KPICard";

type KPIData = {
  id: string;
  title: string;
  value: string | number;
  valueFormat?: string;
  subtitle?: string;
  icon?: IconDefinition;
  seriesData?: (number | null)[];
  seriesType?: "spline" | "line" | "area";
};

type KPICardGridProps = {
  kpiData: KPIData[];
  loading?: boolean;
  columns?: number;
  gap?: string | number;
};

export const KPICardGrid: React.FC<KPICardGridProps> = ({
  kpiData,
  loading = false,
  columns = 2,
  gap = "5px",
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap,
        backgroundColor: theme.palette.background.default,
        p: 0,
      }}
    >
      {kpiData.map((kpi) => (
        <KPICard
          key={kpi.id}
          id={kpi.id}
          title={kpi.title}
          value={kpi.value}
          valueFormat={kpi.valueFormat}
          subtitle={kpi.subtitle}
          icon={kpi.icon}
          seriesData={kpi.seriesData}
          seriesType={kpi.seriesType}
          loading={loading}
          testId={kpi.id}
        />
      ))}
    </Box>
  );
};

export default KPICardGrid;
